export enum SignatureLevels {
	'Nível 1' = 1,
	'Nível 2' = 2,
	'Nível 3' = 3
}

export enum SignatureLevelsTranslation {
	'Level1' = 1,
	'Level2' = 2,
	'Level3' = 3
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/enum/signature-level.ts